/**
 * @flow
 */

import React from "react"
import styled from "styled-components"

type Option = {
  value: string,
  label: string,
}

type Props = {
  field: Object,
  form: Object,
  label?: string,
  options: Array<Option>,
  placeholder?: string,
}

const Container = styled.div`
  margin-bottom: 1rem;
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
  p {
    select {
      border: none;
      border-radius: 8px;
      padding: 0.75rem;
      background-color: var(--white);
      width: 100%;
      font-size: 0.9rem;
      appearance: none;
      &:focus {
        outline: none;
        box-shadow: 2px 2px 10px -8px rgba(0, 0, 0, 0.5);
      }
    }
  }
  span {
    font-size: 0.9rem;
    padding: 0.5rem 0 0 0.5rem;
    display: inline-block;
    color: var(--pomegranate);
  }
`

const SelectField = ({
  field,
  form,
  label = "",
  options = [],
  placeholder = "Please select",
  ...props
}: Props) => {
  const error = form.errors[field.name] && form.touched[field.name]

  const handleBlur = () => {
    form.setFieldTouched(field.name, true)
  }

  const handleChange = event => {
    form.setFieldValue(field.name, event.target.value)
  }

  return (
    <Container>
      <label>{label}</label>
      <p>
        <select
          onBlur={handleBlur}
          onChange={handleChange}
          value={field.value}
          {...props}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </p>
      <span> {error ? form.errors[field.name] : ""} </span>
    </Container>
  )
}

export default SelectField
